import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";

import { OutlinedInput, FormControl, FormHelperText } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
//
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
//
import AutocompleteCom from "../../../Componentes/Kit/AutoComplete/AutocompleteCom";
import { useAuth } from "../../Auth/AuthProtecter";
import useGetCombSelect from "../../../hooks/Consultas/useGetCombSelect";

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(100% - ${theme.spacing(1)})`,
    // maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

const PaymentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "100%",
  height: "auto",
  padding: theme.spacing(2),
  borderRadius: `calc(${theme.shape.borderRadius}px + 4px)`,
  border: "1px solid ",
  borderColor: (theme.vars || theme).palette.divider,
  background:
    "linear-gradient(to bottom right, hsla(220, 35%, 97%, 0.3) 25%, hsla(220, 20%, 88%, 0.3) 100%)",
  boxShadow: "0px 4px 8px hsla(210, 0%, 0%, 0.05)",
  [theme.breakpoints.up("xs")]: {
    height: "auto",
    //height: 300,
  },
  [theme.breakpoints.up("sm")]: {
    // height: 350,
    height: "auto",
  },
  ...theme.applyStyles("dark", {
    background:
      "linear-gradient(to right bottom, hsla(220, 30%, 6%, 0.2) 25%, hsla(220, 20%, 25%, 0.2) 100%)",
    boxShadow: "0px 4px 8px hsl(220, 35%, 0%)",
  }),
}));

const FormGrid = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

// const Url = process.env.REACT_APP_URL;

const PARISH = process.env.REACT_APP_PARISH;
const ECONOMICALACTIVITY = process.env.REACT_APP_ECONOMICALACTIVITY;
const OCCUPATION = process.env.REACT_APP_OCCUPATION;
const CITY = process.env.REACT_APP_CITY;
const STATE = process.env.REACT_APP_STATE;

export default function AddressFormTwo({ ...other }) {
  //
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState(auth.Domain);
  //
  const person = auth.infoUserCheck().person;
  //
  const address = auth.infoUserCheck().address;

  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const dataperson = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //
  const optCountry = [{ id: 238, name: "Venezuela" }];

  const optState = useGetCombSelect(Url, STATE);
  const optOccupation = useGetCombSelect(Url, OCCUPATION);
  const optEconomicalActivity = useGetCombSelect(Url, ECONOMICALACTIVITY);

  // para deshabilitar
  const sfalse = false;
  //Boton
  const [ActiveButtom, setActiveButtom] = React.useState(false);

  // apartment
  const [apartment, setapartment] = React.useState("");
  const [Apartment, setApartment] = React.useState("");
  const [apartmentError, setapartmentError] = React.useState(false);
  const [apartmentErrorMessage, setapartmentErrorMessage] = React.useState("");

  // addresstype
  const [addresstype, setaddresstype] = React.useState("");
  const [Addresstype, setAddresstype] = React.useState("");
  const [addresstypeError, setaddresstypeError] = React.useState(false);
  const [addresstypeErrorMessage, setaddresstypeErrorMessage] =
    React.useState("");

  // avenue
  const [avenue, setavenue] = React.useState("");
  const [Avenue, setAvenue] = React.useState("");
  const [avenueError, setavenueError] = React.useState(false);
  const [avenueErrorMessage, setavenueErrorMessage] = React.useState("");

  // building
  const [building, setbuilding] = React.useState("");
  const [Building, setBuilding] = React.useState("");
  const [buildingError, setbuildingError] = React.useState(false);
  const [buildingErrorMessage, setbuildingErrorMessage] = React.useState("");

  // zone
  const [zone, setzone] = React.useState("");
  const [Zone, setZone] = React.useState("");
  const [zoneError, setzoneError] = React.useState(false);
  const [zoneErrorMessage, setzoneErrorMessage] = React.useState("");

  // floor
  const [floor, setfloor] = React.useState("");
  const [Floor, setFloor] = React.useState("");
  const [floorError, setfloorError] = React.useState(false);
  const [floorErrorMessage, setfloorErrorMessage] = React.useState("");

  // zipcode
  const [zipcode, setzipcode] = React.useState("");
  const [Zipcode, setZipcode] = React.useState("");
  const [zipcodeError, setzipcodeError] = React.useState(false);
  const [zipcodeErrorMessage, setzipcodeErrorMessage] = React.useState("");

  const [monthlyincome, setMonthlyIncome] = useState("");
  const [MonthlyIncome, setMonthlyincome] = useState("");
  const [monthlyIncomeError, setMonthlyIncomeError] = useState(false);
  const [monthlyIncomeErrorMessage, setMonthlyIncomeErrorMessage] =
    useState("");

  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState(false);
  const [cityErrorMessage, setCityErrorMessage] = useState("");

  const [state, setState] = useState("");
  const [stateError, setStateError] = useState(false);
  const [stateErrorMessage, setStateErrorMessage] = useState("");

  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState(false);
  const [countryErrorMessage, setCountryErrorMessage] = useState("");

  const [parish, setParish] = useState("");
  const [parishError, setParishError] = useState(false);
  const [parishErrorMessage, setParishErrorMessage] = useState("");

  const [economicalactivity, setEconomicalActivity] = useState("");
  const [economicalActivityError, setEconomicalActivityError] = useState(false);
  const [economicalActivityErrorMessage, setEconomicalActivityErrorMessage] =
    useState("");

  const [occupation, setOccupation] = useState("");
  const [occupationError, setOccupationError] = useState(false);
  const [occupationErrorMessage, setOccupationErrorMessage] = useState("");

  // Estados para cada uno de los valores
  const [CountryID, setCountryID] = React.useState(null);
  const [StateID, setStateID] = React.useState(null);

  const [CityID, setCityID] = React.useState(null);
  const [optCity, setOptCity] = React.useState([]);

  const [ParishID, setParishID] = React.useState(null);
  const [optParish, setOptParish] = React.useState([]);

  const [EconomicalActivityID, setEconomicalActivityID] = React.useState(null);
  const [OccupationID, setOccupationID] = React.useState(null);

  useEffect(() => {
    const fetchResource = async () => {
      const datePost = {
        idstate: Number(StateID),
      };
      //
      try {
        //
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(datePost),
        };

        const respass = await fetch(`${Url}${CITY}`, jsonpass);
        const res_pass = await respass.json();

        if (respass.status === 200) {
          setOptCity(res_pass);
        } else {
          setOptCity([]);
        }

        //
      } catch (error) {
        //
        console.log(error);
        //
      }
    };
    fetchResource();
  }, [StateID]);

  useEffect(() => {
    const fetchResource = async () => {
      const datePost = {
        idcity: Number(CityID),
      };

      //
      try {
        //
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(datePost),
        };
        //
        const respass = await fetch(`${Url}${PARISH}`, jsonpass);
        //
        const res_pass = await respass.json();
        //
        if (respass.status === 200) {
          setOptParish(res_pass);
        } else {
          const optCodeArea = [
            {
              id: 0,
              name: "Sin resultado",
            },
          ];

          setOptParish(optCodeArea);
        }
        //
      } catch (error) {
        //
        console.log(error);
        //
      }
    };
    fetchResource();
  }, [CityID]);

  window.setTimeout(() => {
    if (address === "~") {
      setaddresstype("~");
      setapartment("~");
      setavenue("~");
      setbuilding("~");
      setzone("~");
      setfloor("~");
      setzipcode("~");
      setCity("~");
      setState("~");
      setCountry("~");
      setParish("~");
    } else {
      const {
        addresstype,
        apartment,
        avenue,
        building,
        city,
        country,
        floor,
        parish,
        state,
        zipcode,
        zone,
      } = address;

      setaddresstype(addresstype);
      setapartment(apartment);
      setavenue(avenue);
      setbuilding(building);
      setzone(zone);
      setfloor(floor);
      setzipcode(zipcode);
      setCity(city);
      setState(state);
      setCountry(country);
      setParish(parish);
    }
  }, 1);
  window.setTimeout(() => {
    if (person === "~") {
      setEconomicalActivity("~");
      setMonthlyIncome("~");
      setOccupation("~");
    } else {
      const { economicalactivity, monthlyincome, occupation } = person;

      setEconomicalActivity(economicalactivity);
      setMonthlyIncome(monthlyincome);
      setOccupation(occupation);
    }
  }, 1);

  /// HandleChange
  const AddresstypeHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setAddresstype(upperCaseValue);
  };

  const ApartmentHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setApartment(upperCaseValue);
  };
  const AvenueHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setAvenue(upperCaseValue);
  };
  const BuildingHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setBuilding(upperCaseValue);
  };
  const ZoneHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setZone(upperCaseValue);
  };
  const FloorHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setFloor(upperCaseValue);
  };
  const ZipcodeHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setZipcode(upperCaseValue);
  };
  const MonthlyincomeHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();

    const regex = /^[0-9,]*\.?[0-9]*$/;

    if (regex.test(upperCaseValue)) {
      const numericValue = upperCaseValue.replace(/\./g, "").replace(",", ".");
      const formattedValue = formatNumber(numericValue).replace(".", ",");

      setMonthlyincome(formatNumber(formattedValue));
    }
  };
  const formatNumber = (value) => {
    if (!value) return "";
    const [integerPart, decimalPart] = value.split(".");
    const formattedInteger = new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: 0,
    }).format(integerPart.replace(/,/g, ""));
    return `${formattedInteger}${decimalPart ? "," + decimalPart : ""}`;
  };

  /// Validar
  const validateInputs = (e) => {
    let isValid = true;
    const nmr = /^\d+$/;

    const addresstype = document.getElementById("addresstype");
    const apartment = document.getElementById("apartment");
    const avenue = document.getElementById("avenue");
    const building = document.getElementById("building");
    const zone = document.getElementById("zone");
    const floor = document.getElementById("floor");
    const zipcode = document.getElementById("zipcode");
    const monthlyincome = document.getElementById("monthlyincome");

    // State
    const state = document.getElementById("state");
    if (state.value) {
      const StateID = optState.find(
        (opcion) => opcion.name.toLowerCase() === state.value.toLowerCase()
      );
      setStateID(StateID.id);
      // console.log("state:", state.value);
    }

    // Country
    const country = document.getElementById("country");
    if (country.value) {
      const CountryID = optCountry.find(
        (opcion) => opcion.name === country.value
      );
      setCountryID(CountryID.id);
    }

    // Updateconst cityGet = document.getElementById("city");
    //console.log(city);
    const CityIDGet = optCity.find(
      (opcion) => opcion.name.toLowerCase() === city.toLowerCase()
    );
    //console.log("**********-----", CityIDGet);

    if (StateID) {
      // City

      // Parish
      const parishGet = document.getElementById("parish");

      // console.log(optParish);

      const ParishID = optParish.find(
        (opcion) => opcion.name.toLowerCase() === parishGet.value.toLowerCase()
      );
      // console.log(ParishID);
    }

    // Economical Activity
    if (economicalactivity === "~") {
      const economicalactivity = document.getElementById("economicalactivity");
      if (economicalactivity.value) {
        const EconomicalActivityID = optEconomicalActivity.find(
          (opcion) =>
            opcion.name.toLowerCase() === economicalactivity.value.toLowerCase()
        );
        setEconomicalActivityID(EconomicalActivityID.id);
      }
    } else {
      const EconomicalActivityID = optEconomicalActivity.find(
        (opcion) =>
          opcion.name.toLowerCase() === economicalactivity.toLowerCase()
      );
      
      console.log(optEconomicalActivity)
      
      console.log(economicalactivity)
      setEconomicalActivityID(EconomicalActivityID.id);
    }
    



    const occupationGet = document.getElementById("occupation");
    // Occupation
    if (occupation === "~") {
      if (occupationGet.value) {
        const OccupationID = optOccupation.find(
          (opcion) =>
            opcion.name.toLowerCase() === occupationGet.value.toLowerCase()
        );
        setOccupationID(OccupationID.id);
      }
    } else {
      if (occupationGet.value) {
        const OccupationID = optOccupation.find(
          (opcion) =>
            opcion.name.toLowerCase() === occupationGet.value.toLowerCase()
        );
        setOccupationID(OccupationID.id);
      }
    }

    if (!addresstype.value) {
      //  console.log("rtgret435");

      setaddresstypeError(true);
      setaddresstypeErrorMessage("Vacio");
      isValid = false;
      // console.log("uy4757");
    } else {
      setaddresstypeError(false);
      setaddresstypeErrorMessage("");
    }

    if (!apartment.value) {
      //  console.log("fgfg65xdd");

      setapartmentError(true);
      setapartmentErrorMessage("Vacio");
      isValid = false;
    } else {
      setapartmentError(false);
      setapartmentErrorMessage("");
    }

    if (!avenue.value) {
      //  console.log("5fth44fch");

      setavenueError(true);
      setavenueErrorMessage("Vacio");
      isValid = false;
    } else {
      setavenueError(false);
      setavenueErrorMessage("");
    }

    if (!building.value) {
      //  console.log("e6rfy5");

      setbuildingError(true);
      setbuildingErrorMessage("Vacio");
      isValid = false;
    } else {
      setbuildingError(false);
      setbuildingErrorMessage("");
    }

    if (!zone.value) {
      //  console.log("jfjgh");

      setzoneError(true);
      setzoneErrorMessage("Vacio");
      isValid = false;
    } else {
      setzoneError(false);
      setzoneErrorMessage("");
    }

    if (!floor.value) {
      setfloorError(true);
      setfloorErrorMessage("Vacio");
      //  console.log("64getr");

      isValid = false;
    } else {
      setfloorError(false);
      setfloorErrorMessage("");
    }

    if (!zipcode.value || !nmr.test(zipcode.value)) {
      // console.log("fsdfdv");

      if (!zipcode.value) {
        setzipcodeError(true);
        setzipcodeErrorMessage("Vacio");
      } else {
        setzipcodeError(true);
        setzipcodeErrorMessage("solo numerico");
      }
      isValid = false;
    } else {
      setzipcodeError(false);
      setzipcodeErrorMessage("");
    }

    if (!monthlyincome.value) {
      // console.log("45hg4kh");

      setMonthlyIncomeError(true);
      setMonthlyIncomeErrorMessage("Vacio");

      isValid = false;
    } else {
      setMonthlyIncomeError(false);
      setMonthlyIncomeErrorMessage("");
    }

    if (city === "~") {
      //  console.log("CityID>>>>", CityID);
      // Validación para City
      if (CityID === null) {
        //  console.log("bjfgh");

        setCityError(true);
        setCityErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setCityError(false);
        setCityErrorMessage("");
      }
    }

    // Validación para State
    if (state === "~") {
      if (StateID === null) {
        // console.log("ts3b35v");

        setStateError(true);
        setStateErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setStateError(false);
        setStateErrorMessage("");
      }
    }

    // Validación para Country
    if (country === "~") {
      // console.log("5456erdt");

      setCountryError(true);
      setCountryErrorMessage("Defina este campo");
      isValid = false;
    } else {
      setCountryError(false);
      setCountryErrorMessage("");
    }

    // Validación para Parish
    if (city === "~") {
      if (ParishID === null) {
        //   console.log("ParishID:", ParishID);
        //  console.log("fghf");
        setParishError(true);
        setParishErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setParishError(false);
        setParishErrorMessage("");
      }
    }

    // Validación para Economical Activity
    if (EconomicalActivityID === null) {
      // console.log("232323");

      setEconomicalActivityError(true);
      setEconomicalActivityErrorMessage("Defina este campo");
      isValid = false;
    } else {
      setEconomicalActivityError(false);
      setEconomicalActivityErrorMessage("");
    }

    // Validación para Occupation
    if (OccupationID === null) {
      // console.log("sfsdf");

      setOccupationError(true);
      setOccupationErrorMessage("Defina este campo");
      isValid = false;
    } else {
      setOccupationError(false);
      setOccupationErrorMessage("");
    }

    if (isValid) {
      const bytes = CryptoJS.AES.decrypt(
        sessionStorage.getItem(LST),
        secretKey
      );
      const array = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      console.log(CityID)
      const updatedValue = {
        ...array,
        addresstype: addresstype.value,
        apartment: apartment.value,
        avenue: avenue.value,
        building: building.value,
        zone: zone.value,
        floor: floor.value,
        zipcode: zipcode.value,
        idcity: city === "~" ? CityID : CityIDGet.id,
        idstate: StateID,
        idcountry: CountryID,
        idparish: parish === "~" ? ParishID : ParishID.id,
        ideconomicalactivity: EconomicalActivityID,
        monthlyincome: parseFloat(
          monthlyincome.value.replace(/\./g, "").replace(",", ".")
        ),
        idoccupation: OccupationID,
      };

      // console.log(updatedValue);
      sessionStorage.setItem(
        LST,
        CryptoJS.AES.encrypt(JSON.stringify(updatedValue), secretKey).toString()
      );

      other.SetActiButtom(isValid);
      setActiveButtom(true);
    } else {
      const updatedValue = {
        addresstype: addresstype.value,
        apartment: apartment.value,
        avenue: avenue.value,
        building: building.value,
        zone: zone.value,
        floor: floor.value,
        zipcode: zipcode.value,
        idcity: city === "~" ? CityID : CityID.id,
        idstate: StateID,
        idcountry: CountryID,
        idparish: ParishID,
        ideconomicalactivity: EconomicalActivityID,
        monthlyincome: parseFloat(
          monthlyincome.value.replace(/\./g, "").replace(",", ".")
        ),
        idoccupation: OccupationID,
      };

      console.log("***********Error", updatedValue);
    }
  };

  return (
    <Stack spacing={{ xs: 2, sm: 3 }} useFlexGap>
      <FormControl component="fieldset" fullWidth>
        <Card>
          <CardActionArea
            sx={{
              ".MuiCardActionArea-focusHighlight": {
                backgroundColor: "transparent",
              },
              "&:focus-visible": {
                backgroundColor: "action.hover",
              },
            }}
          >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AccountBoxIcon
                fontSize="large"
                sx={[
                  (theme) => ({
                    color: "grey.400",
                    ...theme.applyStyles("dark", {
                      color: "grey.600",
                    }),
                  }),
                ]}
              />
              <Typography sx={{ fontWeight: "medium" }}>
                {dataperson.firstname} {dataperson.lastname}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </FormControl>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Alert variant="filled" severity={"warning"}>
          <AlertTitle>
            {
              "Actualmente es posible  actualizar los datos faltantes en su registro. Para cambios y correcciones, recomendamos visitar la sucursal más cercana."
            }
          </AlertTitle>
        </Alert>
        <PaymentContainer>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="subtitle2">Dirección</Typography>
            <ManageAccountsIcon sx={{ color: "text.secondary" }} />
          </Box>
          <ContactPageIcon
            sx={{
              fontSize: { xs: 48, sm: 56 },
              // transform: "rotate(90deg)",
              color: "text.secondary",
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
            }}
          >
            {" "}
            <FormGrid sx={{ flexGrow: 1 }}>
              <FormControl
                error={addresstypeError}
                variant="outlined"
                fullWidth
              >
                <FormLabel htmlFor="addresstype" required>
                  Tipo de vivienda
                </FormLabel>
                <OutlinedInput
                  error={addresstypeError}
                  id="addresstype"
                  autoComplete="addresstype"
                  placeholder="Casa, Apartamento.."
                  required
                  size="small"
                  value={addresstype !== "~" ? addresstype : Addresstype}
                  onChange={AddresstypeHandleChange}
                  disabled={addresstype !== "~" || ActiveButtom ? true : sfalse}
                />
                {addresstypeError && (
                  <FormHelperText>{addresstypeErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
            <FormGrid sx={{ flexGrow: 1 }}>
              <FormControl error={apartmentError} variant="outlined" fullWidth>
                <FormLabel htmlFor="apartment" required>
                  Apartamento{" "}
                </FormLabel>
                <OutlinedInput
                  error={apartmentError}
                  id="apartment"
                  autoComplete="apartment"
                  placeholder="PH, 4A"
                  required
                  size="small"
                  value={apartment !== "~" ? apartment : Apartment}
                  onChange={ApartmentHandleChange}
                  disabled={apartment !== "~" || ActiveButtom ? true : sfalse}
                />
                {apartmentError && (
                  <FormHelperText>{apartmentErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FormGrid sx={{ flexGrow: 1 }}>
              <FormControl error={avenueError} variant="outlined" fullWidth>
                <FormLabel htmlFor="avenue" required>
                  Avenida
                </FormLabel>
                <OutlinedInput
                  error={avenueError}
                  id="avenue"
                  autoComplete="avenue"
                  placeholder="Avenida - calle"
                  required
                  size="small"
                  value={avenue !== "~" ? avenue : Avenue}
                  onChange={AvenueHandleChange}
                  disabled={avenue !== "~" || ActiveButtom ? true : sfalse}
                />
                {avenueError && (
                  <FormHelperText>{avenueErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FormGrid sx={{ flexGrow: 1 }}>
              <FormControl error={buildingError} variant="outlined" fullWidth>
                <FormLabel htmlFor="building" required>
                  Residencia
                </FormLabel>
                <OutlinedInput
                  error={buildingError}
                  id="building"
                  autoComplete="building"
                  placeholder="Nombre donde reside"
                  required
                  size="small"
                  value={building !== "~" ? building : Building}
                  onChange={BuildingHandleChange}
                  disabled={building !== "~" || ActiveButtom ? true : sfalse}
                />
                {buildingError && (
                  <FormHelperText>{buildingErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FormGrid sx={{ flexGrow: 1 }}>
              {country === "~" ? (
                <AutocompleteCom
                  FormLabel={"País"}
                  error={countryError}
                  errorMessage={countryErrorMessage}
                  size="small"
                  placeholder={"Favorites"}
                  id={"country"}
                  autoComplete="country"
                  options={optCountry}
                  setDataId={setCountryID}
                  label={""}
                  required
                  disabled={ActiveButtom}
                />
              ) : (
                <>
                  <FormLabel htmlFor="country" required>
                    País
                  </FormLabel>
                  <OutlinedInput
                    id="country"
                    autoComplete="country"
                    value={country}
                    required
                    size="small"
                    disabled={country !== "~" ? true : false}
                  />
                </>
              )}
            </FormGrid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
            }}
          >
            {" "}
            <FormGrid sx={{ flexGrow: 1 }}>
              {state === "~" ? (
                <AutocompleteCom
                  FormLabel={"Estado"}
                  error={stateError}
                  errorMessage={stateErrorMessage}
                  size="small"
                  placeholder={"Favorites"}
                  id={"state"}
                  autoComplete="state"
                  options={optState}
                  setDataId={setStateID}
                  label={""}
                  required
                  disabled={ActiveButtom}
                />
              ) : (
                <>
                  <FormLabel htmlFor="state" required>
                    Estado
                  </FormLabel>
                  <OutlinedInput
                    id="state"
                    autoComplete="state"
                    value={state}
                    required
                    size="small"
                    disabled={state !== "~" ? true : false}
                  />
                </>
              )}
            </FormGrid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
            }}
          >
            <FormGrid sx={{ flexGrow: 1 }}>
              {city === "~" ? (
                StateID && (
                  <AutocompleteCom
                    FormLabel={"Ciudad"}
                    error={cityError}
                    errorMessage={cityErrorMessage}
                    size="small"
                    placeholder={"Favorites"}
                    id={"city"}
                    autoComplete="city"
                    options={optCity ? optCity : optCountry}
                    setDataId={setCityID}
                    label={""}
                    required
                    disabled={ActiveButtom}
                  />
                )
              ) : (
                <>
                  <FormLabel htmlFor="city" required>
                    Ciudad
                  </FormLabel>
                  <OutlinedInput
                    id="city"
                    autoComplete="city"
                    value={city}
                    required
                    size="small"
                    disabled={city !== "~" ? true : false}
                  />
                </>
              )}
            </FormGrid>
            <FormGrid sx={{ flexGrow: 1 }}>
              {parish === "~" ? (
                StateID && (
                  <AutocompleteCom
                    FormLabel={"Parroquia"}
                    error={parishError}
                    errorMessage={parishErrorMessage}
                    size="small"
                    placeholder={"Favorites"}
                    id={"parish"}
                    autoComplete="parish"
                    options={optParish}
                    setDataId={setParishID}
                    label={""}
                    required
                    disabled={ActiveButtom}
                  />
                )
              ) : (
                <>
                  <FormLabel htmlFor="parish" required>
                    Parroquia
                  </FormLabel>
                  <OutlinedInput
                    id="parish"
                    autoComplete="parish"
                    value={parish}
                    required
                    size="small"
                    disabled={parish !== "~" ? true : false}
                  />
                </>
              )}
            </FormGrid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
            }}
          >
            <FormGrid sx={{ maxWidth: "30%" }}>
              <FormControl error={floorError} variant="outlined" fullWidth>
                <FormLabel htmlFor="floor" required>
                  Piso
                </FormLabel>
                <OutlinedInput
                  error={floorError}
                  id="floor"
                  autoComplete="floor"
                  placeholder="Piso 01, PB"
                  required
                  size="small"
                  value={floor !== "~" ? floor : Floor}
                  onChange={FloorHandleChange}
                  disabled={floor !== "~" || ActiveButtom ? true : sfalse}
                />
                {floorError && (
                  <FormHelperText>{floorErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
            <FormGrid sx={{ maxWidth: "30%" }}>
              <FormControl error={zoneError} variant="outlined" fullWidth>
                <FormLabel htmlFor="zone" required>
                  Zona
                </FormLabel>
                <OutlinedInput
                  error={zoneError}
                  id="zone"
                  autoComplete="zone"
                  placeholder="Sector #"
                  required
                  size="small"
                  value={zone !== "~" ? zone : Zone}
                  onChange={ZoneHandleChange}
                  disabled={zone !== "~" || ActiveButtom ? true : sfalse}
                />
                {zoneError && (
                  <FormHelperText>{zoneErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>

            <FormGrid sx={{ maxWidth: "30%" }}>
              <FormControl error={zipcodeError} variant="outlined" fullWidth>
                <FormLabel htmlFor="zipcode" required>
                  C. P.
                </FormLabel>
                <OutlinedInput
                  error={zipcodeError}
                  id="zipcode"
                  autoComplete="zipcode"
                  placeholder="0000"
                  required
                  size="small"
                  value={zipcode !== "~" ? zipcode : Zipcode}
                  onChange={ZipcodeHandleChange}
                  disabled={zipcode !== "~" || ActiveButtom ? true : sfalse}
                />
                {zipcodeError && (
                  <FormHelperText>{zipcodeErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
          </Box>

          <Box sx={{ display: "flex", gap: 2 }}>
            <FormGrid sx={{ flexGrow: 1 }}>
              {occupation === "~" ? (
                <AutocompleteCom
                  FormLabel={"Ocupación"}
                  error={occupationError}
                  errorMessage={occupationErrorMessage}
                  size="small"
                  placeholder={"Favorites"}
                  id={"occupation"}
                  autoComplete="occupation"
                  options={optOccupation}
                  setDataId={setOccupationID}
                  label={""}
                  required
                  disabled={ActiveButtom}
                />
              ) : (
                <>
                  <FormLabel htmlFor="occupation" required>
                    Ocupación
                  </FormLabel>
                  <OutlinedInput
                    id="occupation"
                    autoComplete="occupation"
                    value={occupation}
                    required
                    size="small"
                    disabled={occupation !== "~" || ActiveButtom ? true : false}
                  />
                </>
              )}
            </FormGrid>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FormGrid sx={{ flexGrow: 1 }}>
              <FormControl
                error={monthlyIncomeError}
                variant="outlined"
                fullWidth
              >
                <FormLabel htmlFor="monthlyincome" required>
                  Ingreso mensual
                </FormLabel>
                <OutlinedInput
                  error={monthlyIncomeError}
                  id="monthlyincome"
                  autoComplete="monthlyincome"
                  placeholder="1.000,00"
                  required
                  size="small"
                  value={monthlyincome !== "~" ? monthlyincome : MonthlyIncome}
                  onChange={MonthlyincomeHandleChange}
                  disabled={
                    monthlyincome !== "~" || ActiveButtom ? true : sfalse
                  }
                />
                {monthlyIncomeError && (
                  <FormHelperText>{monthlyIncomeErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </FormGrid>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FormGrid sx={{ flexGrow: 1 }}>
              {economicalactivity === "~" ? (
                <AutocompleteCom
                  FormLabel={"Act. económica"}
                  error={economicalActivityError}
                  errorMessage={economicalActivityErrorMessage}
                  size="small"
                  placeholder={"Favorites"}
                  id={"economicalactivity"}
                  autoComplete="economicalactivity"
                  options={optEconomicalActivity}
                  setDataId={setEconomicalActivityID}
                  label={""}
                  required
                  disabled={ActiveButtom}
                />
              ) : (
                <>
                  <FormLabel htmlFor="economicalactivity" required>
                    Act. económica
                  </FormLabel>
                  <OutlinedInput
                    id="economicalactivity"
                    autoComplete="economicalactivity"
                    value={economicalactivity}
                    required
                    size="small"
                    disabled={
                      economicalactivity !== "~" || ActiveButtom ? true : false
                    }
                  />
                </>
              )}
            </FormGrid>
          </Box>
          <Button
            sx={{ mt: 5 }}
            disabled={ActiveButtom}
            fullWidth
            variant="contained"
            onClick={validateInputs}
          >
            Guardar
          </Button>
        </PaymentContainer>
      </Box>
    </Stack>
  );
}
